(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("squishMenu", [], factory);
	else if(typeof exports === 'object')
		exports["squishMenu"] = factory();
	else
		root["squishMenu"] = factory();
})(this, function() {
return 